module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av518-a96e563d8fb429592ef0acb4c2faff71.jpg";